import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';

export class PrioritizedBacklogRank extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['develop', 'teamwork'];
  }

  static attributesForModel() {
    return ['prioritizedBacklogRank'];
  }

  get title() {
    return 'Prioritized backlog rank';
  }

  exampleContents(): FieldContentsData {
    return { text: 3 };
  }

  contentsForRecord(record): FieldContentsData {
    const rank = record.prioritizedBacklogRank;

    if (rank) {
      return { text: rank };
    }

    return {};
  }
}
